import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { selectIsLoggedIn } from "@/auth/authSlice";
import {
    sideNavCollapsedHoverOffset,
    sideNavCollapsedWidth,
    sideNavHoverOffset,
    sideNavTransitionDuration,
    sideNavTransitionEasing,
    sideNavWidth,
} from "@/nav/navConstants";
import { useIsHidden } from "@/nav/navHooks";
import { selectNavOpen, selectNavToggleHovered } from "@/nav/navSlice";

export const BaseContainer = ({ children }) => {
    const theme = useTheme();
    const location = useLocation();
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));
    const isNavOpen = useSelector(selectNavOpen);
    const isNavToggleHovered = useSelector(selectNavToggleHovered);
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isNavHidden = useIsHidden();

    const isDashboard =
        location.pathname == "/" || location.pathname == "/dashboard";
    const marginSize = isSmall ? 20 : 40;
    const visibleNavWidth =
        isSmall || isNavHidden
            ? 0
            : isNavOpen
              ? sideNavWidth
              : sideNavCollapsedWidth;
    const hoveredNavDelta =
        !isSmall && !isNavHidden && isNavToggleHovered
            ? isNavOpen
                ? -sideNavHoverOffset
                : sideNavCollapsedHoverOffset
            : 0;
    const contentNavWidth = Math.max(0, visibleNavWidth + hoveredNavDelta);
    const navTransition = `margin ${sideNavTransitionDuration}ms ${sideNavTransitionEasing}, width ${sideNavTransitionDuration}ms ${sideNavTransitionEasing}, margin-left ${sideNavTransitionDuration}ms ${sideNavTransitionEasing}`;

    return (
        <div
            style={{
                width: `calc(100% - ${contentNavWidth + marginSize * 2}px)`,
                flexGrow: 1,
                transition: navTransition,
                marginLeft: contentNavWidth + marginSize,
                marginRight: marginSize,
                minHeight: "100vh",
                paddingTop: isNavHidden
                    ? "60px"
                    : isLoggedIn
                      ? "80px"
                      : "100px",
                paddingBottom: "150px",
                boxSizing: "border-box",
            }}
        >
            {children}
        </div>
    );
};

export default BaseContainer;
